import { ConsentCheckResponse } from './../../Models/ResponseModels/Health/index'
import { createApi } from '@reduxjs/toolkit/query/react'
import { API_ENDPOINTS } from 'Constants'
import {
  FDCreateCeleryResponse,
  FDDetailsResponse,
  InsuranceQuoteResponse,
  PaymentDetailsResponse,
  ProposalFDResponse,
  QuoteDetailsResponse,
  QuoteResponse,
  Tasks,
} from 'Models/ResponseModels/Group'
import { groupQuery } from 'Services/baseQuery'
import {
  ConsentRequestData,
  FDDetailsRequest,
  ICeleryTaskRequest,
  NomineeDetailsRequest,
} from 'Models/RequestModels/Group'

export const groupFDAPI = createApi({
  baseQuery: groupQuery,
  endpoints: (builder) => ({
    // create quote id
    createQuote: builder.mutation<InsuranceQuoteResponse, any>({
      query: (payload) => ({
        url: API_ENDPOINTS.BOB.CREATE_QUOTE_ID_FD,
        method: 'POST',
        body: payload,
      }),
    }),
    // create customer
    createCustomer: builder.mutation<FDDetailsResponse, FDDetailsRequest>({
      query: (payload) => ({
        url: API_ENDPOINTS.BOB.CREATE_CUSTOMER_FD,
        method: 'POST',
        body: payload,
      }),
    }),
    // create celery tasks
    createCeleryTask: builder.mutation<FDCreateCeleryResponse, ICeleryTaskRequest>({
      query: (payload) => ({
        url: API_ENDPOINTS.BOB.CREATE_CELERY_TASK_FD,
        method: 'POST',
        body: payload,
      }),
    }),

    // get quotations
    getQuotations: builder.query<QuoteDetailsResponse, ICeleryTaskRequest>({
      query: (param) => ({
        url: API_ENDPOINTS.BOB.GET_FD_QUOTATIONS,
        method: 'GET',
        params: param,
      }),
    }),

    // create proposal
    createProposal: builder.mutation<ProposalFDResponse, NomineeDetailsRequest>({
      query: (payload) => ({
        url: API_ENDPOINTS.BOB.CREATE_PROPOSALS,
        method: 'POST',
        body: payload,
      }),
    }),

    // get relationships
    getRelationships: builder.query<any, void>({
      query: () => ({
        url: API_ENDPOINTS.BOB.GET_RELATIONSHIP,
        method: 'GET',
      }),
    }),

    // get occupations
    getOccupations: builder.query<any, void>({
      query: () => ({
        url: API_ENDPOINTS.BOB.GET_OCCUPATIONS,
        method: 'GET',
      }),
    }),

    // get genders
    getGenders: builder.query<any, void>({
      query: () => ({
        url: API_ENDPOINTS.BOB.GET_GENDERS,
        method: 'GET',
      }),
    }),
    // get salutations
    getSalutations: builder.query<any, void>({
      query: () => ({
        url: API_ENDPOINTS.BOB.GET_SALUTATIONS,
        method: 'GET',
      }),
    }),

    // get payment status
    getPaymentStatus: builder.query<
      PaymentDetailsResponse,
      { quote_id: string; consent_id: string }
    >({
      query: ({ quote_id, consent_id }) => ({
        url: `${API_ENDPOINTS.BOB.GET_PAYMENT_STATUS}/${quote_id}`,
        method: 'GET',
        params: { consent_id },
      }),
    }),

    // create Consent
    createConsent: builder.mutation<any, ConsentRequestData>({
      query: (payload) => ({
        url: API_ENDPOINTS.BOB.CREATE_CONSENT,
        method: 'POST',
        body: payload,
      }),
    }),

    // get particular quote data
    getQuoteData: builder.query<any[], { code: string }>({
      query: ({ code }) => ({
        url: `${API_ENDPOINTS.BOB.GET_INSURANCE_DATA}`,
        method: 'GET',
        params: { code },
      }),
    }),
    getPlanInfo: builder.query<any, { insurance_code: string }>({
      query: ({ insurance_code }) => ({
        url: `${API_ENDPOINTS.BOB.GET_GROUP_PLAN_INFO}`,
        method: 'GET',
        params: { insurance_code },
      }),
    })
  }),
})

export const {
  useCreateQuoteMutation,
  useCreateCustomerMutation,
  useCreateCeleryTaskMutation,
  useLazyGetQuotationsQuery,
  useCreateProposalMutation,
  useGetRelationshipsQuery,
  useGetOccupationsQuery,
  useGetGendersQuery,
  useGetSalutationsQuery,
  useLazyGetPaymentStatusQuery,
  useLazyGetQuoteDataQuery,
  useCreateConsentMutation,
  useLazyGetPlanInfoQuery
} = groupFDAPI
